import { zodResolver } from '@hookform/resolvers/zod'
import { Grid } from '@mui/joy'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { parkingCardVehicleTypeEnumOptions } from '~/shared/config/constants'
import { Button } from '~/shared/ui/Buttons'
import {
  AutocompleteInput,
  DatePickerInput,
  FormProvider,
  NumericInput,
  TextInput,
} from '~/shared/ui/Form'
import { PlusIcon } from '~/shared/ui/Icons'
import { formSchema, FormValues } from '../EditForm/model'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Form({ onSuccess, isSubmitting }: FormProps) {
  const { t } = useTranslation()
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <TextInput
            label='form.series'
            name='series'
            placeholder='form.enter series'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.number'
            name='number'
            placeholder='form.enter number'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <NumericInput
            label='form.paid amount'
            name='paidAmount'
            placeholder='form.enter paid amount'
            numericProps={{ thousandSeparator: '' }}
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <AutocompleteInput
            label='form.vehicle type'
            name='vehicleType'
            placeholder='form.select vehicle type'
            options={parkingCardVehicleTypeEnumOptions}
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.payment date'
            name='paymentDate'
            placeholder='form.select date'
            readOnly={isSubmitting}
          />
        </Grid>
        <Grid xs={6}>
          <DatePickerInput
            label='form.valid until'
            name='expirationDate'
            placeholder='form.select date'
            readOnly={isSubmitting}
          />
        </Grid>
      </Grid>
      <br />
      <Button
        loading={isSubmitting}
        startDecorator={<PlusIcon />}
        fullWidth
        type='submit'
      >
        {t('button.add')}
      </Button>
    </FormProvider>
  )
}
